import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export const FailedAttemptsSection = () => {
  const failures = [{
    title: 'Afirmaciones Positivas',
    desc: 'Fallan porque tu cuerpo emite una señal de miedo 1,000 veces más potente que tus palabras.'
  }, {
    title: 'Terapia Convencional',
    desc: "Analiza el pasado, lo que a menudo solo sirve para 'fijar' y darle más realidad al trauma en tu campo."
  }, {
    title: 'Manifestar desde la Carencia',
    desc: 'Intentarlo solo le confirma al universo que no tienes lo que pides.'
  }, {
    title: 'Fuerza de Voluntad',
    desc: 'Se agota porque luchas contra un programa subatómico usando solo lógica 3D.'
  }];
  return <section className="py-24 px-4 relative border-t border-sand bg-parchment-dark/30" data-id="element-17">
      <div className="max-w-5xl mx-auto" data-id="element-18">
        <FadeIn data-id="element-19">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-center mb-16 text-brown-heading" data-id="element-20">
            Por qué lo que has intentado{' '}
            <span className="text-amber-accent" data-id="element-21">no funcionó</span>
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-22">
          {failures.map((item, index) => <FadeIn key={index} delay={0.1 * (index + 1)} data-id="element-23">
              <div className="flex gap-4 p-6 rounded-xl bg-parchment border border-sand hover:border-amber-accent/40 transition-colors" data-id="element-24">
                <div className="flex-shrink-0 mt-1" data-id="element-25">
                  <XCircle className="text-amber-accent" size={24} data-id="element-26" />
                </div>
                <div data-id="element-27">
                  <h3 className="text-lg font-semibold text-brown-heading mb-2" data-id="element-28">
                    {item.title}
                  </h3>
                  <p className="text-brown-warm/70 leading-relaxed" data-id="element-29">
                    {item.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};